import { ALLOW_AUTOCOMPLETE } from "@apps/patient-core/injection-tokens";
import { MockBrandService } from "./mocks/brand.service.mock";
import { MockCommonService } from "./mocks/common.service.mock";
import { MockLocalisationService } from "./mocks/localistaion.service.mock";
import { MockPatientActionsService } from "./mocks/patient-actions.service.mock";
import { MockPatientService } from "./mocks/patient.service.mock";
import { MockSessionService } from "./mocks/session.service.mock";
import { ConciergePatientActionsService } from "@apps/concierge-app/src/app/services/derived/patient-actions.service";
import { ConciergePatientsService } from "@apps/concierge-app/src/app/services/derived/patients.service";
import { BaseBrandService } from "@apps/patient-core/src/app/services/abstracts/brand.service";
import { BaseCommonService } from "@apps/patient-core/src/app/services/abstracts/common.service";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { LocalisationService } from "@apps/patient-core/src/app/services/localisation.service";
import { BasePatientActionsService } from "@apps/patient-core/src/app/services/abstracts/patient-actions.service";
import { BasePatientsService } from "@apps/patient-core/src/app/services/abstracts/patients.service";
import { BaseSessionService } from "@apps/patient-core/src/app/services/abstracts/session.service";
import { ConciergeBrandService } from "@apps/concierge-app/src/app/services/derived/brand.service";
import { ConciergeCommonService } from "@apps/concierge-app/src/app/services/derived/common.service";
import { ConciergeConsentService } from "@apps/concierge-app/src/app/services/derived/consent.service";
import { ConciergeAuthService } from "@apps/concierge-app/src/app/services/derived/auth.service";
import { ConciergeSessionService } from "@apps/concierge-app/src/app/services/derived/session.service";
import { PatientBrandService } from "@apps/patient-app/src/app/services/derived/brand.service";
import { PatientCommonService } from "@apps/patient-app/src/app/services/derived/common.service";
import { PatientConsentService } from "@apps/patient-app/src/app/services/derived/consent.service";
import { PatientJWTService } from "@apps/patient-app/src/app/services/derived/jwt.service";
import { PatientActionsService } from "@apps/patient-app/src/app/services/derived/patient-actions.service";
import { PatientsService } from "@apps/patient-app/src/app/services/derived/patients.service";
import { PatientSessionService } from "@apps/patient-app/src/app/services/derived/session.service";
import { MockJWTService } from "@apps/patient-core/mocks/jwt.service.mock";
import { BaseAuthHttpService } from "@apps/patient-core/src/app/services/abstracts/auth-http.service";
import { MockAuthHttpService } from "@apps/patient-core/mocks/auth-http.service.mock";
import { ConciergeAuthHttpService } from "@apps/concierge-app/src/app/services/derived/auth-http.service";
import { PatientAuthHttpService } from "@apps/patient-app/src/app/services/derived/auth-http.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { SetHeadersInterceptor } from "./src/app/http-interceptors/set-headers-interceptor";
import { EnsureHttpsInterceptor } from "./src/app/http-interceptors/ensure-https-interceptor";
import { AuthInterceptor } from "./src/app/http-interceptors/auth-interceptor";
import { ConciergeAuthInterceptor } from "@apps/concierge-app/src/app/http-interceptors/auth-interceptor";
import { BaseConsentService } from "./src/app/services/abstracts/consent.service";

/*
  This provider configuration maps the abstract Base services interface to its concrete implementation.
  Benefits:
  - Components use the interface without knowing the implementation details (loose coupling)
  - Easy to swap implementations by changing only this line
  - Simplifies testing by allowing mock implementations in setup-jest.ts
  - All abstract service mappings are centralized here for better organization
*/
export const CONCIERGE_PROVIDERS = [
  { provide: BaseAuthService, useClass: ConciergeAuthService },
  { provide: BaseAuthHttpService, useClass: ConciergeAuthHttpService },
  { provide: BaseBrandService, useClass: ConciergeBrandService },
  { provide: BaseConsentService, useClass: ConciergeConsentService },
  { provide: BasePatientsService, useClass: ConciergePatientsService },
  { provide: BaseCommonService, useClass: ConciergeCommonService },
  { provide: BaseSessionService, useClass: ConciergeSessionService },
  { provide: BasePatientActionsService, useClass: ConciergePatientActionsService },
  { provide: ALLOW_AUTOCOMPLETE, useValue: false },
];

export const CONCIERGE_HTTP_INTERCEPTORS = [
  { provide: HTTP_INTERCEPTORS, useClass: SetHeadersInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ConciergeAuthInterceptor, multi: true },
];

export const PATIENT_PROVIDERS = [
  { provide: BaseAuthService, useClass: PatientJWTService },
  { provide: BaseAuthHttpService, useClass: PatientAuthHttpService },
  { provide: BaseBrandService, useClass: PatientBrandService },
  { provide: BaseConsentService, useClass: PatientConsentService },
  { provide: BasePatientsService, useClass: PatientsService },
  { provide: BaseCommonService, useClass: PatientCommonService },
  { provide: BaseSessionService, useClass: PatientSessionService },
  { provide: BasePatientActionsService, useClass: PatientActionsService },
  { provide: ALLOW_AUTOCOMPLETE, useValue: true },
];

export const PATIENT_HTTP_INTERCEPTORS = [
  { provide: HTTP_INTERCEPTORS, useClass: SetHeadersInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];

export const SPEC_PROVIDERS = [
  { provide: LocalisationService, useClass: MockLocalisationService },
  { provide: BaseAuthService, useClass: MockJWTService },
  { provide: BaseAuthHttpService, useClass: MockAuthHttpService },
  { provide: BaseBrandService, useClass: MockBrandService },
  { provide: BasePatientsService, useClass: MockPatientService },
  { provide: BaseCommonService, useClass: MockCommonService },
  { provide: BaseSessionService, useClass: MockSessionService },
  { provide: BasePatientActionsService, useClass: MockPatientActionsService },
  { provide: ALLOW_AUTOCOMPLETE, useValue: true },
];
